import { ApiService } from '../model/Api.model';
import { AxiosInstance } from 'axios';
import IQueryExpensesBasicInfo from '../queryStrings/IQueryExpensesBasicInfo';
import { IExpenseDetail } from '../interface/Expense/IExpenseDetail';
import { IExpenseBasicList } from '../interface/Expense/IExpenseBasicList';

enum ExpenseSearchServiceEnum {
	getDetailById = '/',
	getBasicInfo = '/basic-info'
}

export class ExpenseSearchService extends ApiService {
	public detail = {
		get: async (id: number): Promise<IExpenseDetail> => await this.GET(ExpenseSearchServiceEnum.getDetailById + id)
	};

	public basicInfo = {
		get: async (queryString: IQueryExpensesBasicInfo): Promise<IExpenseBasicList> => await this.POST(`${ExpenseSearchServiceEnum.getBasicInfo}`, queryString)
	};

	constructor(restClient: AxiosInstance) {
		super(restClient, '/expense/search');
	}
}
